import { useState, useEffect } from "react";
import { UtilService } from "../shared/UtilService";
import { OptionProps } from "../../constants/types";

const useCompanyList = (branchName: string | {}) => {
  const [data, setData] = useState<OptionProps[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCompanyList = async () => {
      try {
        // Pass the branchName as a payload to the API call
        const response = await UtilService.getCompany({
          branch: branchName,
        });
        const arr = response?.data?.map(
          (i: { businessName: any; businessId: any }) => ({
            id: i?.businessId,
            label: i?.businessName,
            value: i?.businessName,
          })
        );
        setData(arr);
      } catch (err: any) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    Object.keys(branchName).length !== 0 &&
      branchName.constructor !== Object &&
      fetchCompanyList();
  }, [branchName]); // Add branchName as a dependency to re-fetch when it changes

  return { data, loading, error };
};

export default useCompanyList;
